/* eslint-disable no-undef */
import queryString from "query-string";
import urlEncode from "form-urlencoded";
import { remoteConfig } from "../../../config/config";
import { formatContent } from './wordpressHelpers';
import "rss-parser/dist/rss-parser.min.js";


/**
 * Previously, all endpoints looked something like this:
 * https://api15.intouchnetworks.com/authentication
 * We now use subdomains, so we want to use this:
 * https://authentication.api2.intouchnetworks.com/authentication
 * This means that we need to extract the first "folder" from the url variable here:    
 */
function convertOldEndpointToNewFormat(url) {
    let folders  = url.split('/').filter(e => e);                               // filter() removes empty elements
    let endpoint = folders[0];

    /**
     * Note: The path /training/webinar points to the "webinars" API, but /training points to the "training" API.
     */
    if (endpoint == 'training' && folders.length > 1 && 
        (folders[1] == 'webinar' || folders[1] == 'webinars')) {
        endpoint = 'webinars';
    }

    let new_url  = `https://${ endpoint}.${ remoteConfig.urls.api }${ url }`;
    console.log("URL rewritten", url, new_url);
    return new_url;
}

// TODO: Add better error handling
function authenticatedGetRequest( url, params ) {
    return new Promise( ( resolve, reject ) => {
        let constructedUrl = convertOldEndpointToNewFormat(url);

        if ( params ) {
            constructedUrl += `?${ queryString.stringify( params ) }`;
        }

        fetch( constructedUrl, {
            headers: {
                "Authorization": `JWT ${ localStorage.getItem( 'token' ) }`,
                "Referrer": window.location.href,
            }
        } )
        .then( ( response ) => {
            if ( !response.ok ) {
                if( response.status === 401 ) {
                    localStorage.unauthorized = 1;
                    localStorage.removeItem('token');
                    localStorage.removeItem('permissions');
                    location.reload();
                }

                return reject( response );
            }

            return response.json();
        } )
        .then( response => {
            return resolve( response );
        } );
    } );
}

function authenticatedPostRequest( url, body, method = "POST", encoding = "URL" ) {
    return new Promise( ( resolve, reject ) => {
        const constructedUrl = convertOldEndpointToNewFormat(url);
        const headers = {
            'Authorization': `JWT ${ localStorage.getItem( "token" ) }`,
            "Referrer": window.location.href,
        };

        if ( encoding === "URL" ) {
            headers["Content-Type"] = "application/x-www-form-urlencoded";
        }

        fetch( constructedUrl, {
            method,
            headers: headers,
            body: encoding === "URL"
                ? urlEncode( body )
                : body,
        } )
        .then( ( response ) => {
            if ( !response.ok ) {
                if( response.status === 401 ) {
                    localStorage.unauthorized = 1;
                    localStorage.removeItem('token');
                    localStorage.removeItem('permissions');
                    location.reload();
                }

                return reject( response );
            }

            return response.json();
        } )
        .then( response => {
            return resolve( response );
        } );
    } );
}

function unauthenticatedGetRequest( url, params ) {
    return new Promise( ( resolve, reject ) => {
        let constructedUrl = convertOldEndpointToNewFormat(url);
        if ( params ) {
            constructedUrl += `?${ queryString.stringify( params ) }`;
        }

        fetch( constructedUrl )
            .then( ( response ) => {
                if ( !response.ok ) {
                    if( response.status === 401 ) {
                        localStorage.unauthorized = 1;
                        location.reload();
                    }

                    return reject( response );
                }

                return response.json();
            } )
            .then( response => {
                return resolve( response );
            } );
    } );
}

function unauthenticatedPostRequest( url, body, method = "POST", encoding = "URL" ) {
    return new Promise( ( resolve, reject ) => {
        const constructedUrl = convertOldEndpointToNewFormat(url);
        const headers = {
            "Referrer": window.location.href,
        };


        if ( encoding === "URL" ) {
            headers["Content-Type"] = "application/x-www-form-urlencoded";
        }

        fetch( constructedUrl, {
            method,
            headers: headers,
            body: encoding === "URL"
                ? urlEncode( body )
                : body,
        } )
            .then( ( response ) => {

                if ( !response.ok ) {
                    if( response.status === 401 ) {
                        localStorage.unauthorized = 1;
                        location.reload();
                    }

                    return reject( response );
                }

                return response.json();
            } )
            .then( response => {
                return resolve( response );
            } );
    } );
}

function authenticatedDeleteRequest( url, body, method = "DELETE" ) {
    return new Promise( ( resolve, reject ) => {
        const constructedUrl = convertOldEndpointToNewFormat(url);

        const headers = {
            'Authorization': `JWT ${ localStorage.getItem( "token" ) }`,
            "Referrer": window.location.href,
        };

        fetch( constructedUrl, {
            method,
            headers: headers,
        } )
            .then( ( response ) => {
                if ( !response.ok ) {
                    throw response;
                }

                return response.json();
            } )
            .then( ( response ) => {
                return resolve( response );
            } );
    } );
}

function authenticatedPutRequest( url, body, method = "PUT", encoding = "URL") {
  return new Promise( ( resolve, reject ) => {
    const constructedUrl = convertOldEndpointToNewFormat(url);

      const headers = {
          'Authorization': `JWT ${ localStorage.getItem( "token" ) }`,
          "Referrer": window.location.href,
      };

      if ( encoding === "URL" ) {
          headers["Content-Type"] = "application/x-www-form-urlencoded";
      }

      if ( headers ) {
          fetch( constructedUrl, {
              method,
              headers: headers,
              body: encoding === "URL"
                  ? urlEncode( body )
                  : body,
          } )
              .then( ( response ) => {
                  if ( !response.ok ) {
                      throw response;
                  }

                  return response.json();
              } )
              .then( ( response ) => {
                  return resolve( response );
              } );

      }
  } );
}

function authenticatedLaravelGetRequest( url, params ) {
    return new Promise( ( resolve, reject ) => {

        let constructedUrl = `${ url }`;
        if ( params ) {
            constructedUrl += `?${ queryString.stringify( params ) }`;
        }

        fetch( constructedUrl, {
            headers: {
                "Authorization": `JWT ${ localStorage.getItem( 'token' ) }`,
                "Referrer": window.location.href,
            }
        } )
            .then( ( response ) => {
                // console.log( "Get Request Response ", response );
                if ( !response.ok ) {
                    if( response.status === 401 ) {
                        localStorage.unauthorized = 1;
                        localStorage.removeItem('token');
                        localStorage.removeItem('permissions');
                        location.reload();
                    }

                    return reject( response );
                }

                return response.json();
            } )
            .then( response => {
                return resolve( response );
            } );
    } );
}

function getWordPressData( url, isCMS ) {
	return new Promise((resolve, reject) => {
		fetch(`${ url }`)
			.then(async response => {
                if (!response.ok) {
                    return reject(response);
				} else {
                    let headerDetails = {
                        totalItems: response.headers.get("X-WP-Total"),
						totalPages: response.headers.get("X-WP-TotalPages")
					};
					return {
                        headers: headerDetails,
					    json: await response.json()
					};
				}
			})
			.then(response => {
				let formattedData = url.includes('category-overview',0) ? extractCategoryData( response.json, isCMS ) : extractData( response.json, isCMS );
				return resolve({headers: response.headers, data: formattedData});
			})
	})
}

function getWordPressMenuData( url ) {
	return new Promise( ( resolve, reject ) => {
		fetch(`${ url }`)
			.then( response => {
				if (!response.ok) {
					return reject(response);
				}
				return response.json();
			})
			.then( json => {
				let data = {
				    title: null,
                    links: []
                };
				json.map((js, i) => {
					if (js.slug === "sub-nav-1-0") {
					    data.title = js.acf.sub_navigation[0].nav_item;
						js.acf.sub_navigation[0].links.map((j, a) => {
							data.links[a] = {
								linkText: j.link_text,
								pathname: j.path,
							};
                        });
                    }
				});
				return resolve(data);
			})
	})
}

function extractData( data, isCMS ) {
  // this needs to check if fields even have data in first
  if( !isCMS && data.length ){
      return data.map(elem => {
          if(elem.status === "publish") {
              return {
                  title: elem.acf.settings && elem.acf.settings.partnerName,
                  primaryColor: elem.acf.settings && elem.acf.settings.primaryColour,
                  primaryTextColor: elem.acf.settings && elem.acf.settings.primaryTextColor,
                  secondaryColor: elem.acf.settings && elem.acf.settings.secondaryColour,
                  secondaryTextColor: elem.acf.settings && elem.acf.settings.secondaryTextColor,
                  description: elem.acf.settings && elem.acf.settings.partnerDescription,
                  category: elem.acf.settings && elem.acf.settings.partnerCategory,
                  template: elem.template,
                  logo: elem.acf.settings && elem.acf.settings.partnerLogo.url,
                  link: elem.slug,
                }
            }
        })
    } else {
        return {
            content: formatContent(data[0].acf),
            template: data[0].template
        };
    }
}

function extractCategoryData( data, isCMS ) {
  // this needs to check if fields even have data in first
  if( !isCMS && data.length ){
      return data[0].acf.category_list.map(elem => {
              return {
                  title: elem.category_name,
                  logo: elem.category_logo.url,
                  primaryColor: elem.primary_color,
                  short_description: elem.category_short_description,
                  full_description: elem.category_full_description,
                  link: elem.category_name,
                }
            
        })
    } else {
        return {
            content: formatContent(data[0].acf),
            template: data[0].template
        };
    }
}

async function podcastRSSRequest(url) {
    //Add latest episode as last element in the 'ids' array - will be reversed later (grab id from embed code on episode)
    let ids = ["7118315", "7180091", "7557002", "7917998", "8247311", "8630888", "8976857"];
    let CORS_PROXY = "https://cors.intouchnetworks.com/";

    let formatted = [];
    let parser = new RSSParser();
    let rssFeed = await parser.parseURL(CORS_PROXY + url);
    let id = ids.reverse();

    rssFeed.items.map((item, i) => {
        let episode = {
            description: item.content,
            id: id[i], //Horrible, horrible way of getting the ID
            logo: item.itunes.image,
            header: item.title,
        };
        formatted.push(episode);
    });

    return {
        episodes: formatted,
        header: rssFeed.title,
        description: rssFeed.description,
        defaultImage: rssFeed.image.url
    };
}

async function newsRSSRequest() {
    //Add latest episode as last element in the 'ids' array - will be reversed later (grab id from embed code on episode)
    let urls = [
        'http://feeds.bbci.co.uk/news/business/rss.xml?edition=uk',
        'http://feeds.skynews.com/feeds/rss/business.xml',
        'http://rss.nytimes.com/services/xml/rss/nyt/Business.xml',
        'https://feeds.a.dj.com/rss/WSJcomUSBusiness.xml',
      ];
    let CORS_PROXY = "https://cors.intouchnetworks.com/";

    let parser = new RSSParser({
        customFields: {
          item: [
            ['media:thumbnail', 'media', {keepArray: true}],
            ['media:content', 'media', {keepArray: true}],
          ]
        }
      });

    return Promise.all([
            parser.parseURL(CORS_PROXY + urls[0]),
            parser.parseURL(CORS_PROXY + urls[1]),
            parser.parseURL(CORS_PROXY + urls[2]),
            parser.parseURL(CORS_PROXY + urls[3]),
        ]).then(rssData => {
            //Sorty by date, add publisher
            let data = sanitizeNewsRSS(rssData);
            return [...data]
        });
}

function sanitizeNewsRSS(rssData){
    // array[0] -  BBC
    // array[1] -  SkyNews
    // array[2] -  NY Times Business
    // Title, short description, url to rss feed, thumbnail
    let rssArr = rssData.map(rssFeeds => {
        return rssFeeds.items.slice(0, 12)
    });

    //Add publisher (display prepared UI)
    let bbcArr = rssArr[0].map(elem => ({...elem, publisher : "BBC Business News", country: "gb" }));
    let SkyArr = rssArr[1].map(elem => ({...elem, publisher : 'Sky News Business', country: "gb"}));
    let NYtimesArr = rssArr[2].map(elem => ({...elem, publisher : 'New York Times', country: "us"}));
    let wallStreetJournalArr = rssArr[3].map(elem => ({...elem, publisher : 'Wall Street Journal', country: "us"}));

    //1 array
    let concatArr = [].concat(...bbcArr, ...SkyArr, ...NYtimesArr, ...wallStreetJournalArr);

    //Sort by date
    concatArr.sort(function(a,b){
        return new Date(b.pubDate) - new Date(a.pubDate);
      });

    //return array to newsRSSRequest
    return concatArr;
}



// for inline api calls without redux

async function starRatingRequest(id) {
  return authenticatedGetRequest(`/profiles/${id}/star-rating`)
        .then((result) => {
           return result.data.star_rating ? result.data.star_rating: 0;
        })
        .catch((error) => {
          return 0;
      });
}

export function getProfile( personId ) {
    return authenticatedGetRequest( `/profiles/${ personId }` )
    .then( ( result ) => {
        return result;
     })
    .catch((error) => {
   });
}
  
module.exports = {
    unauthenticatedGetRequest,
    unauthenticatedPostRequest,
    authenticatedGetRequest,
    authenticatedPostRequest,
    authenticatedDeleteRequest,
    authenticatedPutRequest,
    authenticatedLaravelGetRequest,
    getWordPressData,
    getWordPressMenuData,
    podcastRSSRequest,
    newsRSSRequest,
    starRatingRequest,
    getProfile
};



// WEBPACK FOOTER //
// src/client/helpers/requests.js